import { render, staticRenderFns } from "./ScriptoriumNewEdit.vue?vue&type=template&id=73147386&scoped=true&"
import script from "./ScriptoriumNewEdit.vue?vue&type=script&lang=js&"
export * from "./ScriptoriumNewEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73147386",
  null
  
)

export default component.exports